var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{pre:true,attrs:{"viewBox":"0 0 8 9","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{pre:true,attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{pre:true,attrs:{"d":"M0 9V1h8v8z"}}),_c('path',{pre:true,attrs:{"stroke":"currentColor","stroke-width":"1.1","stroke-linecap":"round","stroke-linejoin":"round","d":"m2.5 7.5 3-3-3-3"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }